// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./css/animation/_index.scss
// module id = 29
// module chunks = 0